import Component from './message_history_table.vue'
export default Component
